import { colors } from '@material-ui/core';
export default {
  styleOverrides: {
    root: {
      width: 108,
      height: 40,
      // textTransform: 'none',
      // '&:hover': {
      //   backgroundColor: colors.white,
      // },
      fontSize: 14,
      fontFamily: 'Source Han Sans CN, Arial, sans-serif',
      fontWeight: 500,
    },
    contained: {
      // boxShadow:
      //   '0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(0,0,0,0.20)',
      color: '#FFFFFF',
      backgroundColor: colors.blue[800],
      // borderColor: colors.lightBlue[900],
      '&:hover': {
        // backgroundColor: '#0D47A1',
      },
      '&.lastChild': {
        marginRight: 0,
      },
    },
    containedSecondary: {
      color: '#FFFFFF',
      backgroundColor: colors.grey[700],
    },
    outlined: {
      color: '#666464',
      borderColor: colors.blue[800],
    },
  },
};
